(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name commons.controller:ConfirmDialogCtrl
     *
     * @description
     *
     */
    angular
        .module('commons')
        .controller('ConfirmDialogCtrl', ConfirmDialogCtrl);

    function ConfirmDialogCtrl($uibModalInstance, modalParams) {
        var vm = this;

        vm.model = {
            title: modalParams.title,
            msgCol: modalParams.messages || [],
        };

        vm.onCloseClick = function () {
            $uibModalInstance.close(modalParams.close);
        };

        vm.onYesClick = function(){
            $uibModalInstance.close('YES');
        };

        vm.onNoClick = function(){
            $uibModalInstance.close();
        };
    }
}());
